import { motion } from "framer-motion";
import { Check, Loader2, Send } from "lucide-react";
import { AUDIENCES } from "../lib/api";

export const AudienceStep = ({ selected, setSelected, onSubmit, onBack, loading }) => {
  const toggle = (id) =>
    setSelected((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));

  return (
    <motion.section
      data-testid="audience-step"
      initial={{ opacity: 0, x: 40 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -40 }}
      transition={{ type: "spring", stiffness: 220, damping: 26 }}
      className="flex-1 min-h-0 flex flex-col gap-3 py-3"
    >
      <div className="flex items-end justify-between gap-4 shrink-0">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[var(--muted)]">Stap 3 / 3 · meerdere opties mogelijk</p>
          <h2 className="font-display text-2xl sm:text-4xl font-light leading-tight mt-1">
            Wie moet <em className="italic text-[var(--amber)]">dit zien?</em>
          </h2>
        </div>
        <span data-testid="audience-selected-count" className="font-mono-clock text-sm text-[var(--muted)] pb-1">
          {selected.length}/10
        </span>
      </div>

      <div className="flex-1 min-h-0 grid grid-cols-2 grid-rows-5 lg:grid-cols-5 lg:grid-rows-2 gap-2 sm:gap-3">
        {AUDIENCES.map((a, i) => {
          const on = selected.includes(a.id);
          return (
            <motion.button
              key={a.id}
              type="button"
              data-testid={`audience-option-${a.id}`}
              aria-pressed={on}
              onClick={() => toggle(a.id)}
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              whileTap={{ scale: 0.96 }}
              transition={{ delay: i * 0.035, type: "spring", stiffness: 260, damping: 22 }}
              className={`group relative min-h-0 overflow-hidden rounded-2xl border-2 text-left transition-colors ${on ? "border-[var(--amber)]" : "border-transparent"}`}
            >
              <img src={a.img} alt={a.label} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <span className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-black/10" />
              <span className={`absolute top-2 right-2 h-6 w-6 rounded-full flex items-center justify-center border transition-colors ${on ? "bg-[var(--amber)] border-[var(--amber)] text-[var(--ink)]" : "border-white/70 bg-black/30"}`}>
                {on && <Check className="h-4 w-4" />}
              </span>
              <span lang="nl" className="absolute bottom-2 left-3 right-3 leading-tight text-white hyphens-auto [overflow-wrap:anywhere]">
                <span className="block text-sm sm:text-base font-bold">{a.label}</span>
                {a.sub && <span className="block text-xs text-white/85">{a.sub}</span>}
              </span>
            </motion.button>
          );
        })}
      </div>

      <div className="flex items-center justify-between shrink-0">
        <button data-testid="audience-back-btn" onClick={onBack} className="text-sm text-[var(--muted)] hover:text-[var(--paper)] transition-colors">
          ← Terug
        </button>
        <motion.button
          data-testid="submit-review-btn"
          onClick={onSubmit}
          disabled={loading || selected.length === 0}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.95 }}
          className="flex items-center gap-2 rounded-full bg-[var(--amber)] text-[var(--ink)] px-5 py-2.5 text-sm font-bold disabled:opacity-50"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
          Review versturen
        </motion.button>
      </div>
      <p data-testid="recaptcha-notice" className="shrink-0 text-[11px] leading-snug text-[var(--muted)]">
        Beveiligd met reCAPTCHA · Google{" "}
        <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="underline">Privacy</a> en{" "}
        <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer" className="underline">Voorwaarden</a> zijn van toepassing.
      </p>
    </motion.section>
  );
};
